import src from "IMAGE";
export default { src, width: 3600, height: 624, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/APH5/v/u+P7/6vf+/97t9v/e7PX/6vf+/+/5/v/y+v7/+3ce0yq9nVEAAAAASUVORK5CYII="};
